
const state = {
    notes : [],
    editor : false,
    selectedNote : "",
   
  }
  
  const mutations = {
    SET_NOTES: (state, notes) => {
        state.notes = notes
    },
    PUSH_NOTE: (state, notes) => {
        state.notes.unshift(notes)
    },
    
    SET_SELECTED_TICKET: (state, ticket) => {
        state.selectedTicket = ticket
    },
  }
  
  const actions = {
    setNotes({ commit }, attributes) {
        let notes = [];
        try {
            if(attributes.customerInfo) {
                let info = JSON.parse(attributes.customerInfo.value)
                notes = info.notes
                console.log("NOTES STATE SET",notes)
            }
        } catch(e) {
            console.log(e)
        }
        commit('SET_NOTES', notes)
    },
    toggleEditor({ commit }, status) {
        commit('TOGGLE_EDITOR', status)
    },
    toggleTicketButton({ commit }, status) {
        commit('TOGGLE_TICKET_BUTTON', status)
    },
    toggleNoteButton({ commit }, status) {
        commit('TOGGLE_NOTE_BUTTON', status)
    },
    setSelectedTicket({ commit }, ticket) {
        console.log("------------> " + ticket);
        commit('SET_SELECTED_TICKET', ticket)
    },
    pushNotes({ commit }, noteDetails) {
        let note= {}
        note.id = noteDetails.id;
        note.description = noteDetails.description;
        note.createdAt = noteDetails.created_at
        console.log(note)
        commit('PUSH_Note', note)
    },
  
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  
  